(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["related-products"]) return;
  try {
    
  const handleIntersection = (entries, observer) => {
    if (!entries[0].isIntersecting) return;

    observer.unobserve(productRecommendationsSection);
    const url = productRecommendationsSection.dataset.url;

    fetch(url)
      .then(response => response.text()) 
      .then(text => {
        const html = document.createElement('div');
        html.innerHTML = text;
        const recommendations = html.querySelector('.product-recommendations');
        if (recommendations && recommendations.innerHTML.trim().length) {
          productRecommendationsSection.innerHTML = recommendations.innerHTML;
          if($('.product-recommendations .ProductGridItem').length > 7){
            $('.product-recommendations .ProductGridItem').last().remove();
          }
        }

        $(window).trigger('reinit-recommendations');
        $('.product-recommendations.slideshow').addClass('fader');
        $(window).trigger('resize');
        $(window).trigger('scroll');


        $('.product-recommendations .ProductGridItem').mouseover(function(){
          var overlay = $(this).find('.overlay'); 
          var src = overlay.attr('data-src');
          overlay.css('background-image', 'url('+src+')');
        }); 

        $('.product-recommendations .ProductGridItem.taphover').bind('touchstart', function (e) {
          'use strict'; //satisfy code inspectors
          var link = $(this); //preselect the link

          var overlay = $(this).find('.overlay'); 
          var src = overlay.attr('data-src');
          overlay.css('background-image', 'url('+src+')');
    
          
          if (link.hasClass('hover')) {
              return true;
          } else {
              link.addClass('hover');
              $('a.taphover').not(this).removeClass('hover');
              $('a.button').not(this).removeClass('hover');
              //e.preventDefault();
              return true; //extra, and to make sure the function has consistent return points
          }
        });
      })
      .catch(e => {
        console.error(e);
      });
  };

  const productRecommendationsSection = document.querySelector('.product-recommendations');
  const observer = new IntersectionObserver(handleIntersection, {rootMargin: '0px 0px 200px 0px'});

  observer.observe(productRecommendationsSection);

  } catch(e) { console.error(e); }
})();
})();
